import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BulletList, BulletListItem, Callout, Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { rejectionLine } from './FailuresCallout.utils';
export const GetFailuresCalloutTID = (parentTestId)=>getTestIds(parentTestId);
export function FailuresCallout(param) {
    let { failures, unreadableRows, testId } = param;
    const { t: texts } = useLocaleKeys('pages.importClients');
    const { FailuresCalloutTestIds: TID } = useMemo(()=>GetFailuresCalloutTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(Callout, {
        skin: "standard",
        intent: "error",
        testId: TID.Root(),
        footer: /*#__PURE__*/ _jsxs(Column, {
            gap: 12,
            children: [
                failures.map((failure, index)=>/*#__PURE__*/ _jsxs(Column, {
                        gap: 4,
                        testId: TID.FailureClient(index),
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                weight: "bold",
                                children: failure.customerName
                            }),
                            /*#__PURE__*/ _jsx(BulletList, {
                                children: failure.reasons.map((rejection, i)=>/*#__PURE__*/ _jsx(BulletListItem, {
                                        variant: "paragraph3",
                                        children: rejectionLine(rejection, texts)
                                    }, "".concat(rejection.rowNumber, "-").concat(i)))
                            })
                        ]
                    }, "".concat(failure.customerName, "-").concat(index))),
                unreadableRows.length > 0 && /*#__PURE__*/ _jsxs(Column, {
                    gap: 4,
                    testId: TID.UnreadableRows(),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph3",
                            weight: "bold",
                            children: texts.results.unreadableRowsHeader()
                        }),
                        /*#__PURE__*/ _jsx(BulletList, {
                            children: /*#__PURE__*/ _jsx(BulletListItem, {
                                variant: "paragraph3",
                                children: unreadableRows.join(', ')
                            })
                        })
                    ]
                })
            ]
        }),
        children: texts.results.failuresHeader()
    });
}
